import React, { useState, useEffect } from 'react';
import { Routes, Route, useNavigate, useSearchParams } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { functions } from '../../config/firebaseConfig';
import { httpsCallable } from 'firebase/functions';
import GoogleAuthRedirect from './GoogleAuth/GoogleAuthRedirect';
import SuccessAndRedirect from './SuccessAndRedirect';
import VerifyEmail from './VerifyEmail';
import GoogleButton from './GoogleAuth/Button';
import EmailPasswordAuth from './EmailPasswordAuth';
import InputCell from '../../components/InputCell';
import Button from '../../components/Button';
import { checkIfUserIsLoggedIn } from '../../redux/actions';
import { validateEmail } from '../../scripts/formValidator';
import logo from '../../../assets/images/logo192.png';
import { displayToast } from '../../components/Toast';
import OpenInNewTab from '../../components/OpenInNewTab';
var AuthRoutes = function () {
    var searchParams = useSearchParams()[0];
    var electronAuthCode = searchParams.get('auth-code');
    var dispatch = useAppDispatch();
    useEffect(function () {
        dispatch(checkIfUserIsLoggedIn());
    }, []);
    // set team-plan if user selects it
    useEffect(function () {
        var paramsObject = Object.fromEntries(searchParams);
        if (paramsObject['team-plan'] || paramsObject['team-plan'] === '') {
            console.log('exists');
            sessionStorage.setItem('team-plan', 'true');
        }
    }, []);
    return (React.createElement("div", { className: 'bg-primary text-primary flex h-screen w-screen flex-col items-center justify-center' },
        React.createElement(Routes, null,
            React.createElement(Route, { path: '/', element: React.createElement(RenderAuth, null) }),
            React.createElement(Route, { path: '/chrome', element: React.createElement(RenderAuth, { transmitAuth: 'chrome' }) }),
            React.createElement(Route, { path: 'google', element: React.createElement(GoogleAuthRedirect, { electronAuthCode: electronAuthCode }) }),
            React.createElement(Route, { path: 'verify-email', element: React.createElement(VerifyEmail, null) }),
            React.createElement(Route, { path: 'success', element: React.createElement(SuccessAndRedirect, null) }))));
};
var RenderAuth = function (_a) {
    var transmitAuth = _a.transmitAuth;
    var navigate = useNavigate();
    var _b = useAppSelector(function (_a) {
        var auth = _a.auth;
        return {
            isSignedIn: auth.isSignedIn,
            emailVerified: auth.emailVerified,
        };
    }), isSignedIn = _b.isSignedIn, emailVerified = _b.emailVerified;
    var _c = useState(''), email = _c[0], setEmail = _c[1];
    var _d = useState(false), useEmailPasswordAuthentication = _d[0], setUseEmailPasswordAuthentication = _d[1];
    var _e = useState(false), emailIsValid = _e[0], setEmailIsValid = _e[1];
    useEffect(function () {
        // handles authentication of chrome extension
        if (transmitAuth && isSignedIn) {
            httpsCallable(functions, 'generateCustomToken')()
                .then(function (token) {
                var editorExtensionId = process.env.NODE_ENV === 'development'
                    ? 'difbbklacmfkmdbjodggcblijefhpied'
                    : 'gjinmppmhegelfojkghdjpbakhalligk';
                if (window.chrome.runtime) {
                    window.chrome.runtime.sendMessage(editorExtensionId, { token: token });
                    window.chrome.runtime.sendMessage('jnegkdafmnehfdkopipndjgkjdicpcig', {
                        token: token,
                    }); // unpacked prod - to remove
                    displayToast('success', 'Chrome Extension authenticated!');
                }
                else {
                    displayToast('error', 'Could not authenticate Browser extension.');
                }
            })
                .catch(function (err) {
                console.log(err);
            });
        }
        // handles redirects
        if (isSignedIn) {
            if (emailVerified) {
                navigate('/');
            }
            else {
                navigate('verify-email');
            }
        }
    }, [isSignedIn]);
    return emailIsValid && useEmailPasswordAuthentication ? (React.createElement(EmailPasswordAuth, { email: email })) : (React.createElement("div", { className: 'auth-form m-4 flex flex-col items-center gap-3' },
        React.createElement("img", { className: 'mb-2 w-20', alt: 'substratum logo', src: logo }),
        React.createElement("h2", { className: 'mb-3 font-display' }, "Substratum"),
        React.createElement("p", { className: 'text-secondary' }, "Sign in with an existing account or create a new one."),
        React.createElement("div", { className: 'mt-4 flex w-full max-w-xs flex-col gap-3 text-center' },
            React.createElement(GoogleButton, { label: 'Continue with Google' }),
            React.createElement("p", { className: 'text-secondary text-sm' }, "or"),
            React.createElement("form", { className: 'flex w-full max-w-xs flex-col gap-3 text-center' },
                React.createElement(InputCell, { id: 'email', type: 'email', placeholder: 'Enter your email address', value: email, autoComplete: 'on', onChange: setEmail, displayError: !emailIsValid && useEmailPasswordAuthentication, errorMessage: 'Email is not valid' }),
                React.createElement(Button, { label: 'Continue with email', onClick: function () {
                        setUseEmailPasswordAuthentication(true);
                        setEmailIsValid(validateEmail(email).isValidEmail);
                    }, id: 'continue-with-email' }))),
        React.createElement("p", { className: 'text-secondary mt-4 max-w-xs text-center text-xs ' },
            "By proceeding, you confirm that you have read and agree to Substratum\u2019s",
            ' ',
            React.createElement(OpenInNewTab, { href: '/terms-and-conditions' }, "Terms & Conditions"),
            ' ',
            "and ",
            React.createElement(OpenInNewTab, { href: '/privacy-policy' }, "Privacy Policy"),
            ".")));
};
export default AuthRoutes;
